import {
  Box
} from '@mui/material'
import getRoundedNumber from 'src/utils/getRoundedNumber'

const container = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '400px',
  maxWidth: '100%'
}

const barstyle = {
  position: 'relative',
  backgroundColor: 'black',
  color: 'white',
  width: '324px',
  maxWidth: '100%'
}

const emptyBarStyle = {
  ...barstyle,
  border: '1px solid white',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'center'
}
const filledBarStyle = {
  ...barstyle,
  backgroundColor: 'white',
  marginLeft: '1px',
  marginRight: '1px',
  transition: 'width .2s',
  transitionTimingFunction: 'ease-out'
}

type SimpleBarProps = {
  currentValue: number
  maximumValue: number
  label?: string
  barHeight?: number
  textMargin?: number
  hideValues?: boolean
  color?: string
  className?: string
  hideOutline?: boolean
}

const SimpleBar = ({currentValue, maximumValue, barHeight, textMargin, label, hideValues, color = 'white', className, hideOutline = false}: SimpleBarProps) => {
  const fullSize = !!(hideValues && label === undefined)
  return (
    <Box sx={container} className={className ?? 'simple-bar'}>
      { !fullSize && label ? (
        <span style={{ marginRight: textMargin ? `${textMargin}px` : '16px', width: fullSize ? 0 : 'fit-content', textAlign: 'left', color}}>{label}</span>
      ) : null }
      <Box sx={{ ...emptyBarStyle, borderColor: hideOutline ? 'transparent' : color, height: barHeight ? `${barHeight}px` : '16px', flexGrow: '100'}}>
        <Box sx={{ ...filledBarStyle, backgroundColor: color, height: barHeight ? `${barHeight - 4}px` : '12px', width: `${currentValue * 100 / maximumValue}%` }} />
      </Box>
      { !fullSize && !hideValues ? (
        <span style={{ marginLeft: textMargin ? `${textMargin}px` : '16px', width: fullSize ? 0 : 'fit-content', textAlign: 'right', color}}>{hideValues ? '' : `${getRoundedNumber(currentValue)}/${maximumValue}`}</span>
      ) : null }
    </Box>
  )
} 

export default SimpleBar
